export const FETCHING_WARRANTY_ERROR_CODES_LIST = '@@toyota/FETCHING_WARRANTY_ERROR_CODES_LIST';
export const FETCHED_WARRANTY_ERROR_CODES_LIST = '@@toyota/FETCHED_WARRANTY_ERROR_CODES_LIST';
export const FETCHED_WARRANTY_ERROR_CODES_LIST_FAILED = '@@toyota/FETCHED_WARRANTY_ERROR_CODES_LIST_FAILED';
export const CLEAR_WARRANTY_ERROR_CODES_LIST = '@@toyota/CLEAR_WARRANTY_ERROR_CODES_LIST';

export const ADDING_WARRANTY_ERROR_CODE = '@@toyota/ADDING_WARRANTY_ERROR_CODE';
export const ADDED_WARRANTY_ERROR_CODE = '@@toyota/ADDED_WARRANTY_ERROR_CODE';
export const ADDED_WARRANTY_ERROR_CODE_FAILED =
  '@@toyota/ADDED_WARRANTY_ERROR_CODE_FAILED';

export const FETCHING_WARRANTY_ERROR_CODE = '@@toyota/FETCHING_WARRANTY_ERROR_CODE';
export const FETCHED_WARRANTY_ERROR_CODE = '@@toyota/FETCHED_WARRANTY_ERROR_CODE';
export const FETCHED_WARRANTY_ERROR_CODE_FAILED =
  '@@toyota/FETCHED_WARRANTY_ERROR_CODE_FAILED';

export const UPDATING_WARRANTY_ERROR_CODE = '@@toyota/UPDATING_WARRANTY_ERROR_CODE';
export const UPDATED_WARRANTY_ERROR_CODE = '@@toyota/UPDATED_WARRANTY_ERROR_CODE';
export const UPDATED_WARRANTY_ERROR_CODE_FAILED =
  '@@toyota/UPDATED_WARRANTY_ERROR_CODE_FAILED';

export const CLEAN_WARRANTY_ERROR_CODE = '@@toyota/CLEAN_WARRANTY_ERROR_CODE';

export const FETCHING_WARRANTY_TASK_CODES_LIST = '@@toyota/FETCHING_WARRANTY_TASK_CODES_LIST';
export const FETCHED_WARRANTY_TASK_CODES_LIST = '@@toyota/FETCHED_WARRANTY_TASK_CODES_LIST';
export const FETCHED_WARRANTY_TASK_CODES_LIST_FAILED = '@@toyota/FETCHED_WARRANTY_TASK_CODES_LIST_FAILED';
export const CLEAR_WARRANTY_TASK_CODES_LIST = '@@toyota/CLEAR_WARRANTY_TASK_CODES_LIST';
export const ADDING_WARRANTY_TASK_CODE = '@@toyota/ADDING_WARRANTY_TASK_CODE';
export const ADDED_WARRANTY_TASK_CODE = '@@toyota/ADDED_WARRANTY_TASK_CODE';
export const ADDED_WARRANTY_TASK_CODE_FAILED =
  '@@toyota/ADDED_WARRANTY_TASK_CODE_FAILED';
export const FETCHING_WARRANTY_TASK_CODE = '@@toyota/FETCHING_WARRANTY_TASK_CODE';
export const FETCHED_WARRANTY_TASK_CODE = '@@toyota/FETCHED_WARRANTY_TASK_CODE';
export const FETCHED_WARRANTY_TASK_CODE_FAILED =
  '@@toyota/FETCHED_WARRANTY_TASK_CODE_FAILED';
export const UPDATING_WARRANTY_TASK_CODE = '@@toyota/UPDATING_WARRANTY_TASK_CODE';
export const UPDATED_WARRANTY_TASK_CODE = '@@toyota/UPDATED_WARRANTY_TASK_CODE';
export const UPDATED_WARRANTY_TASK_CODE_FAILED =
  '@@toyota/UPDATED_WARRANTY_TASK_CODE_FAILED';
export const CLEAN_WARRANTY_TASK_CODE = '@@toyota/CLEAN_WARRANTY_TASK_CODE';
export const RESIZE_WARRANTY_TASK_CODES_PAGE =
  '@@toyota/RESIZE_WARRANTY_TASK_CODES_PAGE';
export const CHANGE_WARRANTY_TASK_CODES_PAGE = '@@toyota/CHANGE_WARRANTY_TASK_CODES_PAGE';
